import { render, staticRenderFns } from "./offersComponent.vue?vue&type=template&id=76146b6a"
import script from "./offersComponent.vue?vue&type=script&lang=js"
export * from "./offersComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports